export default {
  baseApi: 'https://m.yhtianmu.cn/prod-api', //
  appName: '餐饮油烟管理智慧平台',
  whiteList: ['/login', '/Notification', '/SpecificLogin'],
  uploadApi: 'https://m.yhtianmu.cn/prod-api'
}
